import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from './menu-item';

@Injectable()
export class MenuService {

    menuItems: Array<MenuItem> = [];

    constructor() { }

    addMenu(items: Array<MenuItem>) {
        items.forEach((item) => {
            this.menuItems.push(item);
        });
    }

    getMenu() {
        return this.menuItems;
    }

}
